import React from "react";
import styled from "styled-components";

import Space from "../core/Space";
import FormText from "./FormText";

const FormRadioButton = ({ children, active, disabled, onClick ,...rest}) => {
  return (
    <RadioButton onClick={disabled ? null : onClick} $disabled={disabled} {...rest}>
      {
        disabled ?
          <RadioButtonDisabled />
          :
          <>
            {
              active ?
                <RadioButtonActive>
                  <RadioButtonActiveCircle />
                </RadioButtonActive>
                :
                <RadioButtonInactive />
            }
          </>
      }
      <Space width={0} />

      <FormText style={disabled ? { color: "var(--aia-bx-gray-5)" } : {}}>{children}</FormText>
    </RadioButton>
  );
};

const RadioButtonInactive = styled.div`
  width: 26px;
  height: 26px;
  border: 1px solid var(--aia-bx-gray-5);
  border-radius: 50%;
`;

const RadioButtonActive = styled.div`
  width: 26px;
  height: 26px;
  border: 1px solid var(--aia-bx-blue-2);
  border-radius: 50%;
  display: flex;
  justify-content: center;
  align-items: center;
`;

const RadioButtonDisabled = styled.div`
  width: 26px;
  height: 26px;
  border-radius: 50%;
  border: 1px solid var(--aia-bx-gray-5);
  background-color: var(--aia-bx-gray-4);
`;

const RadioButtonActiveCircle = styled.div`
  width: 18px;
  height: 18px;
  background-color: var(--aia-bx-blue-2);
  border-radius: 50%;
`;

const RadioButton = styled.button`
  display: flex;
  align-items: center;
  gap: 5px;
  width: fit-content;
  border: 0px;
  background: transparent;
  cursor: pointer;
  padding: 3px 5px;

  &:hover ${RadioButtonInactive} {
    border-color: var(--aia-bx-blue-2);
    box-shadow: 0px 0px 0.5rem 0px rgba(2, 114, 174, 0.2);
  }

  &:hover ${RadioButtonActive} {
    border-color: var(--aia-bx-blue-2);
    box-shadow: 0px 0px 0.5rem 0px rgba(2, 114, 174, 0.2);
  }

  &:hover ${RadioButtonActiveCircle} {
    background-color: var(--aia-bx-blue-6);
  }

  ${props => props.$disabled && `
    cursor: not-allowed;
  `}
`;

export default FormRadioButton;